module.exports = __webpack_public_path__ + "img/profile.1a591b85.svg";